import { MEMBRESIA } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null,
    setup_intent: null,
    pagos: []
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case MEMBRESIA.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case MEMBRESIA.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case MEMBRESIA.SETUP_INTENT:
            return {
                ...state,
                setup_intent: payload
            };

        case MEMBRESIA.PAGOS:
            return {
                ...state,
                pagos: payload
            };

        default:
            return state;
    }
}
